import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { InputTextComponent } from './input-text.component';
import { MatIconModule } from '@angular/material/icon';
import { InputTextService } from './input-text.service';
import { InputText } from '../utils/models/InputText';

const maskConfig: Partial<IConfig> = {
  validation: false,
};


@NgModule({
  declarations: [InputTextComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    MatIconModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(maskConfig)
  ],
  exports: [InputTextComponent]
})
export class InputTextModule {
  static forRoot(inputText: InputText = new InputText()): ModuleWithProviders<InputTextModule> {
    return {
      ngModule: InputTextModule,
      providers: [
        { provide: 'INPUT_TEXT_FORMAT', useValue: inputText.format },
        { provide: 'INPUT_TEXT_SHOW_LABEL', useValue: inputText.showLabel },
        { provide: 'INPUT_TEXT_BTN_ENABLE', useValue: inputText.btnEnable },
        { provide: 'INPUT_TEXT_BOLD', useValue: inputText.bold },
        { provide: 'INPUT_TEXT_TEXT_RIGHT', useValue: inputText.textRight },
        { provide: 'INPUT_TEXT_VALIDATOR_MESSAGE', useValue: inputText.validatorMessage },
        { provide: 'INPUT_TEXT_TOOLTIP_MESSAGE', useValue: inputText.tooltipMessage },
        { provide: 'INPUT_TEXT_SUBMITTED', useValue: inputText.submitted },
        { provide: 'INPUT_TEXT_VALIDATOR_ALERT', useValue: inputText.validatorAlert },
        InputTextService
      ]
    }
  }
}
